<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Form Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.formEntegration">Form Aktif</a-checkbox>
                </div>
                <div class="feature-label">Form Oluşturma Limiti</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.formLimit" />
                </div>
                <div class="feature-label">Form Submit Limit</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.formSubmitLimit" />
                </div>
                <div class="feature-label">Form Başına Görüntüleme Limiti</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.formViewLimit" />
                </div>
                <div class="feature-label">Form Alan Sayısı</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.formFieldLimit" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "FormFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            formEntegration: true,
            formLimit: 0,
            formSubmitLimit: 0,
            formViewLimit: 0,
            formFieldLimit: 0,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.FORM);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.FORM, ...this.featureForm };
                response[Features.FORM.LIMIT] = +v.formLimit || 0;
                response[Features.FORM.SUBMIT_LIMIT] = +v.formSubmitLimit || 0;
                response[Features.FORM.VIEW_LIMIT] = +v.formViewLimit || 0;
                response[Features.FORM.FIELD_LIMIT] = +v.formFieldLimit || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.FORM);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
